<template>
  <div>
    <!-- Title -->
    <h4 class="text-primary text-center mb-2">
      {{ $t('tabs.pixel.details') }}
    </h4>

    <!-- General Information -->
    <b-card class="mb-1">
      <b-card-title>{{ $t('columns.generalInfo') }}</b-card-title>
      <b-row>
        <b-col class="mb-1" cols="12" xl="12">
          <label>{{ $t('columns.orgId') }}</label>
          <organization-select-box v-model="pixel.orgId"/>
        </b-col>

        <b-col cols="12" md="6">
          <label>{{ $t('columns.pixel') }}</label>
          <b-form-input v-model="pixel.pixel" />
        </b-col>

        <b-col cols="12" md="6">
          <label>{{ $t('columns.pixelNumber') }}</label>
          <b-form-input v-model="pixel.pixelNumber" />
        </b-col>

        <b-col cols="12" md="6">
          <label>{{ $t('columns.pixelToken') }}</label>
          <b-form-input type="password" v-model="pixel.pixelToken" />
        </b-col>

        <b-col cols="12" md="6">
          <label>{{ $t('columns.agencyName') }}</label>
          <b-form-input v-model="pixel.agencyName" />
        </b-col>

      </b-row>
    </b-card>

    <!-- Actions -->
    <div class="text-center mt-2">
      <b-button size="sm" variant="outline-warning" @click="reset">
        {{ $t('operations.reset') }}
      </b-button>
      &nbsp;
      <b-button size="sm" variant="outline-success" @click="save">
        {{ $t('operations.save') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import Pixel from '@/model/campaign/Pixel'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import { mapActions, mapGetters } from 'vuex'
import OrganizationSelectBox from '@/components/widget/select/OrganizationSelectBox.vue';

export default {
  name: 'PixelEditDetails',
  components: { OrganizationSelectBox },
  mixins: [mixinNotifications, mixinPermissions],
  data() {
    return {
      pixel: Pixel()
    }
  },
  props: {
    value: { type: Object, default: () => ({}) }
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
    organizationOptions() {
      return this.allOrganizations || []
    }
  },
  watch: {
    value: {
      handler(val) {
        this.pixel = Object.assign(Pixel(), val)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('pixel', ['createPixel', 'updatePixel']),
    async save() {
      if (!this.pixel.id) {
        await this.createPixel({ pixel: this.pixel })
        this.showSuccessNotification(
            this.$t('globalMessages.addDataSuccess', { system: this.$t('menu.pixels') })
        )
      } else {
        await this.updatePixel({ pixel: this.pixel, id: this.pixel.id })
        this.showSuccessNotification(
            this.$t('globalMessages.updateDataSuccess', { system: this.$t('menu.pixels') })
        )
      }
      this.refreshTables();
      this.$emit('input', this.pixel)
      this.$emit('close')
    },
    reset() {
      this.pixel = Pixel()
    }
  }
}
</script>
